import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useParams, useHistory, generatePath} from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import SigningTabLayout from '../components/SigningTabLayout';
import {requestSigningSession} from '../api/renewalClickApi';
import {SIGNING_SESSION_FAILED_EVENT} from '../constants/renewalClick';
import {reportToRenewalTab} from '../utils/signingTab';
import {RenewalClickRoute} from '../../../config/routes';

// Opened by the renewal tab. A DocuSign recipient-view URL is single use and expires
// within minutes, so it is issued here, right before redirecting to it.
const SigningRedirectScreen = () => {
  const intl = useIntl();
  const {shortLinkKey} = useParams();
  const history = useHistory();

  useEffect(() => {
    const redirectToDocuSign = async () => {
      try {
        const session = await requestSigningSession(shortLinkKey);
        if (!session?.signingUrl) {
          // Backend answers 200 with {success:false, error} — surface that reason.
          throw new Error(session?.error || session?.message || 'no signingUrl in response');
        }
        window.location.replace(session.signingUrl);
      } catch (error) {
        window.rollbar?.error('Renewal signing session failed', {shortLinkKey, error});
        if (!reportToRenewalTab(shortLinkKey, SIGNING_SESSION_FAILED_EVENT)) {
          history.replace(generatePath(RenewalClickRoute.pathname, {shortLinkKey}));
        }
      }
    };
    redirectToDocuSign();
  }, [shortLinkKey, history]);

  return (
    <SigningTabLayout
      icon={<CircularProgress size={38} />}
      title={intl.formatMessage({id: 'renewalClick.signing.redirecting'})}
    />
  );
};

export default SigningRedirectScreen;
